import { toast } from 'react-toastify';
import { TOOLTIP_MESSAGE } from '../../../Constants/Constants';
import { TShowMoreButtonProps } from './ShowMoreButton.type';

export const showLoadCount = (totalRecords: number, currentPage: number, pageSize: number) => {
  let remainingCount = totalRecords - pageSize * (currentPage + 1);
  if (remainingCount >= pageSize) return pageSize;
  if (remainingCount < pageSize && remainingCount > 0) return remainingCount;
  return null;
};

const ShowMoreButton = (props: TShowMoreButtonProps) => {
  const {
    totalLoadCount,
    pageNumber,
    perPageMaxLoadCapacity,
    handleShowMore = () => toast(TOOLTIP_MESSAGE),
  } = props;
  const loadCount = () => showLoadCount(totalLoadCount, pageNumber, perPageMaxLoadCapacity);
  if (!loadCount()) return null;

  return (
    <div className="ShowMoreButton">
      <button className="primary-cta-btn" onClick={handleShowMore} data-testid="ShowMoreButton">
        Show {loadCount()} More
      </button>
    </div>
  );
};

export default ShowMoreButton;
